import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import background from "assets/images/login_photo.png";
import papsImg from "assets/images/logo-bleu.svg";
import { Button } from "ui/Button";
import { useMutation } from "@apollo/client";
import TextField from "components/TextField";
import { theme } from "config/theme";
import { CircularProgress } from "@material-ui/core";
import { ResetPasswordMutation } from "../graphql/mutations";
import { ArrowBackIcon } from "icons";
import { useNavigate } from "react-router-dom";
import useText from "constants/text";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0),
      height: "100%",
      width: "100%",
      background: "#fff",
      display: "flex",
      justifyContent: "center",
    },
    papsers: {
      width: "40%",
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "@media(max-width: 616px)": {
        visibility: "hidden",
      },
    },
    login: {
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    container: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      flexDirection: "column",
    },
    group: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "4%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    imgDiv: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    title: {
      paddingTop: "10%",
      marginLeft: "auto",
      marginRight: "auto",
      color: theme.palette.primary.main,
      padding: theme.spacing(2),
      fontWeight: 900,
      fontSize: 42,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      "& .MuiTextField-root, .MuiFormControl-root ": {
        margin: theme.spacing(1),
        width: "45ch",
        backgroundColor: "#f2f2f2",
        borderRaduis: 4.7,
      },
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: "10%",
    },
    buttons: {
      width: "45ch",
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      height: "3.5ch",
      justifyContent: "space-between",
      marginTop: 8,
      padding:"auto",
      position:"relative",
    },
    arrow_back:{
      display:"flex",
      position:"absolute",
      left:-10,
      top:-6,
      padding:"auto",
      color:"#399ebf"

      
    },
    arrow_back_icon: {
       position:"relative",
       cursor:"pointer",
       top:-5
    },
    log: {
      background: theme.palette.primary.main,
      width: "14ch",
      color: "#fff",
      fontSize: 16.8,
      marginLeft: "auto",
      padding:"auto"
    },
    pwd: {
      color: theme.palette.primary.main,
    },
    socials: {
      width: "45ch",
      display: "flex",
      marginTop: 10,
      justifyContent: "space-between",
      marginLeft: "auto",
      marginRight: "auto",
    },
    social: {
      borderRadius: 4.2,
      border: "solid 0.9px rgba(0, 0, 0, 0.1)",
      width: "58ch",
      marginTop: 30,
      marginBottom: "auto",
      display: "flex",
      fontSize: 12,
      color: "#9c9292",
      padding: 10,
    },
    icon: {
      marginTop: "auto",
      marginBottom: "auto",
      padding: 5,
    },
    text: {
      marginTop: "auto",
      marginBottom: "auto",
    },
    email: {
      marginLeft: "auto",
      marginRight: "auto",
      color: "#c1bcbc",
    },
  })
);
const defaultLogger = {
  email: "",
};
export function ResetPassword() {
  const styles = useStyles();
  const [logger, setLogger] = React.useState(defaultLogger);
  const [forgetPassword, { loading, error }] = useMutation(ResetPasswordMutation);
  const [message, setMessage] = React.useState(null);
  const navigation = useNavigate();
  const { text } = useText();


  const onChanged = (event: any) => {
    event.persist();
    setLogger((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handlerAuthentification = async (event: any) => {
    event.preventDefault();
    forgetPassword({
      variables: {
        input: logger,
      },
    })
      .then((response) => {
        const { message:msg, code } = response.data?.clientForgotPassword;
        if (code === 200) {
          setLogger(defaultLogger);
        }
        setMessage(msg);
      })
      .catch(() => {
        setMessage(text.all.email_verified_message);
      });
  };
  const handlerGoBack =  () => {
    navigation("/login");
  };
  return (
    <main className={styles.root}>
      <div className={styles.papsers} />
      <div className={styles.login}>
        <div className={styles.container}>
          <div className={styles.group}>
            <div className={styles.imgDiv}>
              <img
                src={papsImg}
                alt="paps icon"
                css={`
                  margin-left: auto;
                  margin-right: auto;
                `}
              />
            </div>
            <div className={styles.title}>Reset your password</div>
            <div
              className={styles.email}
              style={{
                color: error ? "red" : theme.palette.primary.main,
              }}
            >
              {message}
            </div>
          </div>
          <form className={styles.form} onSubmit={handlerAuthentification}>
            <div>
              <TextField
                id="outlined-textarea"
                label="Email"
                placeholder="Email"
                variant="outlined"
                value={logger.email}
                type="email"
                onChange={onChanged}
                name="email"
                required
              />
            </div>
            <div className={styles.buttons}>
              <div className={styles.arrow_back}>
                <p onClick={handlerGoBack} className={styles.arrow_back_icon}><ArrowBackIcon/></p> <p>{text.all.back_to_login}</p>
              </div>
               <div className={styles.log}>
                <Button className={styles.log} type="submit">
                  {loading ? <CircularProgress style={{ color: "white" }} /> : " Confirm "}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default ResetPassword;
